<app-top-bar></app-top-bar>
<app-sidebar></app-sidebar>
<div class="h-full flex flex-col pt-[calc(var(--top-bar-height))]  sm:pt-[calc(var(--top-bar-height))]">
    <div class="grow h-full">
        <router-outlet></router-outlet>
    </div>
    <footer>
        <!-- footer content -->
    </footer>
</div>
